import React from "react";

const PortfolioUIUXInner = () => {
  return (
    <div className="portfolio-area-1 space-top space-bottom">
      {/* <div className="shadow-shape-right" /> */}
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="title-area text-center">
              <span className="sub-title">
                <img src="/assets/img/icon/title_left.svg" alt="shape" />
                Our Portfolio
              </span>
              <h2 className="sec-title style2">
              Latest Projects of UI/UX Designs {" "}
              </h2>
            </div>
          </div>
        </div>

        <div className="goal-tabs-wrapper mainTabs_div">
          <div
            className="nav nav-tabs goal-tabs-tabs port_tabs"
            id="nav-tab"
            role="tablist"
          >
            <button
              className="nav-link active"
              id="nav-step1-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-step1"
              type="button"
            >
              Web Applications
            </button>
            <button
              className="nav-link"
              id="nav-step2-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-step2"
              type="button"
            >
              Mobile Applications
            </button>
            {/* <button
              className="nav-link"
              id="nav-step3-tab"
              data-bs-toggle="tab"
              data-bs-target="#nav-step3"
              type="button"
            >
              Websites
            </button> */}
            
          </div>
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade active show"
              id="nav-step1"
              role="tabpanel"
            >
              <div className="row gy-30 gx-30 masonary-active">
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                    
                    <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/web-applications/Clozium.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/dGoHGG1yAU6Rg1NaYfvWRT/Clozium-Saas-Wireframes?node-id=0-1&p=f&t=186b7nroPOnG18t5-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/web-applications/Clozium.jpg"
                          alt="img"
                        />
                      </a>
                    </div>

                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                    
                    <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/web-applications/smart-home.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/cX1pxNQpXara1MKErPQlR5/Smart-Home-AI-Web-App-by-Digious-Solutions?node-id=0-1&p=f&t=S6etVF2zHwaVT4Jn-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/web-applications/smart-home.jpg"
                          alt="img"
                        />
                      </a>
                    </div>

                  </div>
                </div>
                
              </div>
            </div>
            <div className="tab-pane fade" id="nav-step2" role="tabpanel">
              <div className="row gy-30 gx-30 masonary-active">
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/mobile-applications/Coffee-Shop.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/bUQjsjENtzAwOxmEzODKOq/Coffee-Shop-Mobile-App-Design?node-id=417-154&p=f"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/mobile-applications/Coffee-Shop.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/mobile-applications/smart-home.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/fbp3CMAEBUwhqQtFZlzjXY/Smart-Home-AI-by-Digious-Solutions?node-id=0-1&p=f&t=aCQvaOkbst3nOD9y-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/mobile-applications/smart-home.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>
            <div className="tab-pane fade" id="nav-step3" role="tabpanel">
              <div className="row gy-30 gx-30 masonary-active">
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/UGC-Hub.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/Q1y1IFoK2tRiHJsQLmtTlu/UGC-Hub?node-id=0-1&p=f&t=2TOgirgYxlL4bfZ2-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/UGC-Hub.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/Legacy-Marker.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/M26lDNPKQXopnaXC28hKNt/LegacyMarker-Final?node-id=8842-479&p=f&t=YbjTtm2BkFv7I8WK-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/Legacy-Marker.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/AV-Website-Design.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/8j1aVRScBxnHwU7RfLcIuH/AV-Website-Design?node-id=322-13027&t=GmHMzMBlOXTg4dEF-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/AV-Website-Design.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/Hardhat.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/Gv2m69sVcHNYUqnZMNW1Lk/Hardhat-Launch?node-id=0-1&p=f&t=NjFokeLvoWyv6ssp-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/Hardhat.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/Source.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/5eNEyTykvaF3ezPba15qwO/Jas-%26-Ella-Review?node-id=0-1&p=f&t=TK4BDeSDDM9kG0QW-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/Source.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/paradise.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/YqRY63tRhI5JjLhaCc26Ah/Untitled?node-id=0-1&p=f&t=IFVeqSImDOMPsYNg-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/paradise.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/Fizz-Cleaning-Services.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/qtUfx8hxSSRyxWShI33Egx/Fizz-Cleaning?node-id=1-2&t=qslG6bI8dM7DDS2x-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/Fizz-Cleaning-Services.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 filter-item">
                  <div className="portfolio-box">
                  <div
                      style={{
                        backgroundImage:
                          "url(/assets/img/portfolio/uiux/websites/home-of-training.jpg)",
                      }}
                      className="portfolio-box-thumb screen"
                    >
                      <a
                        href="https://www.figma.com/design/dWHXCdqVLhcrJ2L78qppI5/Home-of-Training-by-Digious-Solutions?node-id=1-2940&t=juYraCdu2K1hbtiT-0"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          className="invisible"
                          src="/assets/img/portfolio/uiux/websites/home-of-training.jpg"
                          alt="img"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                
                
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioUIUXInner;
